import { JSXElementConstructor, memo } from "react";
import { Flex } from "../flex";
import { UserImage, UserImageSize } from "../user-image";
import * as avatarCss from "./avatar.module.css";

const AVATAR_SIZE_CLASS_MAP = {
  small: avatarCss.smallAvatarContainer,
  regular: avatarCss.avatarContainer,
  large: avatarCss.largeAvatarContainer,
} as const;

/** Arbiter-compliant Avatar. TODO: doesn't support all variants, sizes, etc. Add as you need. */
export const Avatar = memo(function Avatar({
  name,
  imageUrl,
  alt,
  imageSize = UserImageSize.SMALL,
  DefaultIcon,
  size = "regular",
  uiSelector,
}: {
  name?: string;
  imageUrl: string | null;
  imageSize?: UserImageSize;
  alt: string;
  DefaultIcon?: JSXElementConstructor<any>;
  size?: "small" | "regular" | "large";
  uiSelector?: string;
}) {
  return (
    <Flex
      align="center"
      className={AVATAR_SIZE_CLASS_MAP[size]}
      data-ui={uiSelector}
      justify="center"
      pt="xs"
    >
      <UserImage
        alt={alt}
        DefaultIcon={DefaultIcon}
        imageUrl={imageUrl}
        name={name}
        size={imageSize}
      />
    </Flex>
  );
});
